const QUALITIES = [
  {
    title: 'Respectful',
    content: 'Respect eachother and value the opinions of others.'
  },
  {
    title: 'Passionate',
    content: 'A deep interest drives learning and improvement.'
  },
  {
    title: 'Motivated',
    content: 'Doing the little extra things makes all the difference.'
  },
  {
    title: 'Determined',
    content: 'Every defeat is an opprotunity for success.'
  },
  {
    title: 'Creative',
    content: 'Make connections between events or situations.'
  },
  {
    title: 'Trustful',
    content: 'We rely on each other to achieve our goals.'
  }
]

export default QUALITIES
